import { render, staticRenderFns } from "./SpecificationSectionPartCreate.vue?vue&type=template&id=37a896ef"
import script from "./SpecificationSectionPartCreate.vue?vue&type=script&lang=js"
export * from "./SpecificationSectionPartCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports